//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'contenedorSemanal_Id';

export default function ReportePesos_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: 'proveedor',
            sort: 'asc',
        },
    ]);
    const intl = useIntl();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'proveedor',
            headerName: intl.formatMessage({ id: 'Proveedor' }),
            editable: false,
            flex: 90,
        },
        {
            field: 'naviera',
            headerName: intl.formatMessage({ id: 'Naviera' }),
            editable: false,
            flex: 90,
        },
        {
            field: 'bl',
            headerName: intl.formatMessage({ id: 'BL' }),
            editable: false,
            width: 220,
        },
        {
            field: 'destino',
            headerName: intl.formatMessage({ id: 'Destino' }),
            editable: false,
            flex: 90,
        },
        {
            field: 'contenedor',
            headerName: intl.formatMessage({ id: 'Contenedor' }),
            editable: false,
            width: 120,
        },
        {
            field: 'etiquetaEspecial',
            headerName: intl.formatMessage({ id: 'EtiquetaEspecial' }),
            editable: false,
            flex: 120,
        },
        {
            field: 'fechaDeCarga',
            headerName: intl.formatMessage({ id: 'FechaDeCarga' }),
            editable: false,
            flex: 90,
            renderCell: (params) => {
                //return params.row['fechaDeCarga'].slice(0, 10)
                return new Date(params.row['fechaDeCarga']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
            }
        },
        {
            field: 'cajas',
            headerName: intl.formatMessage({ id: 'Cajas' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'paletizados',
            headerName: intl.formatMessage({ id: 'Paletas' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'pesoBruto',
            headerName: intl.formatMessage({ id: 'PesoBruto' }),
            editable: false,
            flex: 60,
            renderCell: (params) => {
                const value = params.row['pesoBruto'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        {
            field: 'pesoNeto',
            headerName: intl.formatMessage({ id: 'PesoNeto' }),
            editable: false,
            flex: 60,
            renderCell: (params) => {
                const value = params.row['pesoNeto'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        {
            field: 'pesoTara',
            headerName: intl.formatMessage({ id: 'PesoTara' }),
            editable: false,
            flex: 60,
            renderCell: (params) => {
                const value = params.row['pesoTara'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        {
            field: 'vgm',
            headerName: intl.formatMessage({ id: 'VGM' }),
            editable: false,
            width: 80,
            renderCell: (params) => {
                const value = params.row['vgm'];
                return value != null ? value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0';
            },
        },
        

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        contenedorSemanal_Id: false,
    });
    return (
        <div>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: false },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
